import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prestation',
  templateUrl: './prestation.component.html',
  styleUrls: ['./prestation.component.css']
})
export class PrestationComponent implements OnInit {
prestations = 
   [
      { id:1, description:"Anniversaires",  prix:"450€"  },
      { id:2, description:"Mariages", prix:"700€ à 1000€" },
      { id:3, description:"Bals", prix:"650 à 1500€" },
      { id:4, description:"Soirée CE",  prix:"700€ à 3000€" },
      { id:5, description:"Soirée entre amis (piscine)",  prix:"600€"  },
      { id:6, description:"Sonorisation d’événements sportifs / culturels",  prix:" 290€ à 4000€"  },
      { id:7, description:"Éclairage scénique",  prix:"700€ à 1400€"  },
      { id:8, description:"DJ seul sans matériel",  prix:"250€"  },
      { id:9, description:"Light jockey seul sans matériel",  prix:"250€"  },
      { id:10, description:"Location de matériel son avec technicien",  prix:"676€"  },
      { id:10, description:"Location de matériel éclairage avec technicien",  prix:"976€"  }
    ]

  constructor() { }

  ngOnInit() {
  }

}
